"use strict";
globalThis.WizardConfig = /* @__PURE__ */ (() => {
  const serviceStateKeys = {
    kozijnen: ["hout", "glas", "afwerking", "ral", "montage", "elements", "estimate", "currentWidth", "currentHeight", "currentType", "currentVakken"],
    deuren: ["deurAfwerking", "deurMontage", "deurOptie", "deurType", "deurWidth", "deurHeight"],
    houtrot: ["rot-tier-1", "rot-tier-2", "rot-tier-3"],
    inspectie: []
  };
  const routes = {
    // Step 0: Postcode -> Service
    "0": "1",
    // Step 1: Service Selection -> Specific Flow
    "1": (state) => {
      const service = state.service;
      switch (service) {
        case "kozijnen":
          return "2";
        case "deuren":
          return "2-deuren";
        case "houtrot":
          return "2-houtrot";
        case "inspectie":
          return "contact";
        default:
          return "2";
      }
    },
    // --- Kozijnen Flow ---
    "2": "2b",
    // Hout -> Glas
    "2b": "2c",
    // Glas -> Afwerking
    "2c": (state) => {
      return state.afwerking === "lak" ? "2e" : "2d";
    },
    "2e": (state) => {
      return state.service === "deuren" ? "2b-deuren" : "2d";
    },
    "2d": "3a",
    // Montage -> Afmetingen
    "3a": (state) => {
      return "3";
    },
    "3": "media",
    // Indeling -> Media/Summary
    // --- Deuren Flow ---
    "2-deuren": (state) => {
      return state.deurAfwerking === "lak" ? "2e" : "2b-deuren";
    },
    "2b-deuren": "2c-deuren",
    // Montage -> Optie
    "2c-deuren": "media",
    // Optie -> Media
    // --- Houtrot Flow ---
    "2-houtrot": "media",
    // Qty -> Media/Contact
    // --- Inspectie Flow ---
    // --- Shared Ends ---
    "media": "contact"
    // 'contact' is the final step - form submission handled there
  };
  const validation = {
    "0": { field: "userPostcode", rule: "postcode" },
    "1": { field: "service", rule: "required" },
    // Kozijnen
    "2": { field: "hout", rule: "required" },
    "2b": { field: "glas", rule: "required" },
    "2c": { field: "afwerking", rule: "required" },
    "2e": { field: "ral", rule: "required" },
    "2d": { field: "montage", rule: "required" },
    "3a": {
      rule: "custom",
      message: "Afmetingen zijn verplicht",
      validator: (state) => {
        return true;
      }
    },
    "3": {
      rule: "custom",
      message: "Voeg minimaal \xE9\xE9n element toe",
      validator: (state) => {
        return state.elements && state.elements.length > 0;
      }
    },
    // Deuren
    "2-deuren": { field: "deurAfwerking", rule: "required" },
    "2b-deuren": { field: "deurMontage", rule: "required" },
    "2c-deuren": { field: "deurOptie", rule: "optional" },
    // Houtrot
    "2-houtrot": {
      rule: "custom",
      message: "Selecteer minimaal \xE9\xE9n plek met houtrot",
      validator: (state) => {
        const total = (state["rot-tier-1"] || 0) + (state["rot-tier-2"] || 0) + (state["rot-tier-3"] || 0);
        return total > 0;
      }
    },
    // Inspectie
  };
  return {
    routes,
    validation,
    serviceStateKeys
  };
})();
